import { render } from "./StandardV2Home.vue?vue&type=template&id=37fa4055&scoped=true"
import script from "./StandardV2Home.vue?vue&type=script&lang=js"
export * from "./StandardV2Home.vue?vue&type=script&lang=js"

import "./StandardV2Home.vue?vue&type=style&index=0&id=37fa4055&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37fa4055"]])

export default __exports__